import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';
import { DS, tableHeadCellSx } from './ds';

interface DataTableProps {
  headers: string[];
  lastHeaderAlign?: 'left' | 'center' | 'right';
  children: React.ReactNode;
  emptyMessage?: string;
  isEmpty?: boolean;
}

const DataTable = ({
  headers,
  lastHeaderAlign = 'center',
  children,
  emptyMessage = 'No hay registros para mostrar.',
  isEmpty = false,
}: DataTableProps) => (
  <Table>
    <TableHead>
      <TableRow sx={{ bgcolor: DS.gray }}>
        {headers.map((header, i) => (
          <TableCell
            key={header}
            align={i === headers.length - 1 ? lastHeaderAlign : 'left'}
            sx={tableHeadCellSx}
          >
            {header}
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
    <TableBody>
      {isEmpty ? (
        <TableRow>
          <TableCell colSpan={headers.length} align="center" sx={{ py: 5 }}>
            <Typography color={DS.textSecondary} fontSize={14}>
              {emptyMessage}
            </Typography>
          </TableCell>
        </TableRow>
      ) : (
        children
      )}
    </TableBody>
  </Table>
);

export default DataTable;
